<template>
    <div :id="`section-${index + 1}`" :class="['flex layout-70-30 m-row section', classes.watermark]">
        <p :class="['m-align-c', classes.yearLabel]" v-if="mobile">{{ startYear }}</p>
        <div class="copy layout m-span">
            <p v-for="(segment, s) in story.Segments" :key="s" v-html="segment"></p>
        </div>
        <div :class="['layout p-desktop year', classes.yearPosition]">
            <div :class="['row year-marker', classes.yearPosition]">
                <div class="marker"></div>
                <h2 :class="classes.yearLabel">{{ startYear }}</h2>
                <div class="marker"></div>
            </div>
            <div class="arrow"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StorySection",
    props: {
        story: Object,
        index: Number,
        mobile: Boolean,
        totalYears: Number
    },
    data: () => ({
        classes: {
            yearPosition: "",
            yearLabel: "",
            watermark: ""
        },
        startYear: ""
    }),
    beforeMount: function() {
        const { YearPosition, StartYear, ShowWatermark } = this.story;
        this.classes = {
            yearPosition: YearPosition === "Top" ? "flex-x-center" : "flex-center",
            yearLabel: StartYear ? "year-label" : "year-today",
            watermark: ShowWatermark ? "section-watermark" : ""
        };

        // Year label
        const firstYear = this.index === 0;
        const lastYear = this.index === this.totalYears - 1;
        this.startYear = StartYear;
        if (firstYear) {
            this.startYear = "Beginning";
        }
        if (lastYear) {
            this.startYear = "Today";
        }

    }
};
</script>